export { isNotLoggedInAbort }

// True when `err` is the `Abort({ notLoggedIn: true })` a telefunction throws for an
// unauthenticated caller (see `getCustomerOrAbort`). Telefunc attaches `.abortValue` to the
// client-side Error when a server fn throws Abort (undefined for non-abort errors — a network
// failure, a 500, etc.), and dispatches that abort to BOTH the global `onAbort` handler (→
// `useTelefuncAbort` reloads to <Login>) AND the awaiting call — so a form's own `catch` must
// recognise it and bow out: it's an expected session-expiry, not a bug to log (console.error →
// Sentry) or surface as a generic error. One home so both sites agree.
function isNotLoggedInAbort(err: unknown): boolean {
  return (err as { abortValue?: { notLoggedIn?: boolean } } | undefined)?.abortValue?.notLoggedIn === true
}
